import { render, staticRenderFns } from "./revenueBreakdown.vue?vue&type=template&id=9f5a0396&scoped=true&"
import script from "./revenueBreakdown.vue?vue&type=script&lang=js&"
export * from "./revenueBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./revenueBreakdown.vue?vue&type=style&index=0&id=9f5a0396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5a0396",
  null
  
)

export default component.exports